
<template>
  <div class="grid p-1 mt-2 ml-1">
    <div class="col-2">
      <MultiSelect v-model="SearchFilter.OrganizationIds" :options="Organizations" dataKey="orgId" optionValue="orgId" optionLabel="orgName" placeholder="Select Organization" display="chip" @change="FilterQuestions" />
    </div>

    <div class="col-2">
      <MultiSelect v-model="SearchFilter.MajorIntents" :options="MajorIntents" dataKey="majorIntentId" optionValue="majorIntentId" optionLabel="intentName" placeholder="Select Category" display="chip" @change="FilterQuestions"/>
    </div>
    <div class="col-2">
      <MultiSelect v-model="SearchFilter.MinorIntents" :options="MinorIntents" dataKey="id" optionLabel="name" optionValue="id" placeholder="Select Subcategory" display="chip" @change="FilterQuestions"/>
    </div>
    <div class="col-2">
      <MultiSelect v-model="SearchFilter.DynamicFilters" :options="DynamicFilters" dataKey="id" optionLabel="name" optionValue="fieldName" placeholder="Advanced Filter" display="chip" />
    </div>

    <!--<div class="col-2">
    <MultiSelect v-model="SearchFilter.QuestionTypes" :options="QuestionTypes." dataKey="typeId" optionLabel="typeName" optionValue="typeId" placeholder="Question Type" display="chip" />
  </div>-->

    <div class="col-2">
      <InputText type="text" v-model="SearchFilter.Search" placeholder="Filter Results" @input="FilterExistingItems" @keyup="FilterExistingItems"/>
    </div>
    <div class="col-2">
      <Button icon="pi pi-plus" class="p-button-rounded p-button-primary p-button-outlined mt-1 mr-1"  @click="ShowAddNewQuestions" v-tooltip.top="'Create New Question'" />

      <Button icon="pi pi-cog" class="p-button-rounded p-button-info p-button-outlined mt-1" v-if="!DisableBulkOptions" @click="ShowBulkMenu" v-tooltip.top="'Bulk Update Questions'" />
    </div>
  </div>

  <div class="grid p-1 mt-2" style="height: 70%">
    <div class="col-12" style="width: 100%; height: 100%;">
      <ag-grid-vue style="width: 100%; height: 100%;"
                   :columnDefs="columnDefs"
                   class="ag-theme-material"
                   :defaultColDef="DefaultColumnDefs"
                   @grid-ready="onGridReady"
                   :rowSelection="rowSelection"
                   @selection-changed="onSelectionChanged"
                   @cell-value-changed="handleCellEditing"
                   :gridOptions="gridOptions"
                   :suppressRowClickSelection="true"
                   :rowBuffer="25"
                   :domLayout="autoHeight"
                   :masterDetail="true"
                   :detailRowAutoHeight="true"
                   :detailCellRenderer="detailCellRenderer"
                   :detailCellRendererParams="detailCellRendererParams"
                   :enableCellTextSelection="true"
                   :ensureDomOrder="true"
                   :suppressRowHoverHighlight="false"
                   :sortingOrder="sortingOrder"
                   :pagination="false"
                   :animateRows="true"
                   :statusBar="statusBar"
                   :rowData="rowData">
      </ag-grid-vue>
    </div>
    <Toast />

    <Dialog header="Header" v-model:visible="ShowBulkEditMenu" :breakpoints="{'960px': '75vw', '640px': '100vw'}" position="topright">
      <template #header>
        <h5>Bulk Edit Questions</h5>
      </template>
      <div col="12">
        <Dropdown v-model="BulkEdit.IsApproved" :options="FlagItems" optionLabel="text" optionValue="value" placeholder="Approval Status" />
      </div>
      <template #footer>
        <Button label="Cancel" icon="pi pi-times" class="p-button-danger p-button-sm mr-1" @click="ShowBulkEditMenu = false" />
        <Button label="Update Questions" icon="pi pi-check" autofocus class="p-button-sm" @click="BulkEditItems" :loading="IsBulkEditing" :disabled="IsBulkEditing" />
      </template>
    </Dialog>


    <Dialog header="Header" v-model:visible="ShowAddNewQuestionsMenu" :breakpoints="{'960px': '75vw', '640px': '100vw'}" position="top" modal="true" :maximizable="true" :style="{width: '100vw'}">
      <template #header>
        <div class="grid w-full">
          <div class="col-6">
            <h5>Add New Questions</h5>
          </div>
          <div class="col-6">
            <Button icon="pi pi-plus" class="p-button-rounded p-button-primary p-button-outlined mt-1 mr-5" @click="AddNewCreateQuestion" v-tooltip.top="'Add New Question To List'" />
            <Button icon="pi pi-check" class="p-button-rounded p-button-success p-button-outlined mt-1" @click="CreateNewQuestions" :loading="IsCreatingNewQuestions" v-tooltip.top="'Save Questions'" :disabled="v$.NewQuestions.$invalid"/>
          </div>
        </div>
      </template>
          <div class="grid mb-2 scalein animation-duration-500" v-for="(item, index) in state.NewQuestions" :key="index">
            <Divider align="center">
              <span class="p-tag">Question #{{item.QuestionKey}}</span>
            </Divider>
            <div class="col-12">
              <Card>
                <template #header>
                  <div class="grid flex">
                    <div class="col-4 ml-3">
                      <Dropdown v-model="item.MinorIntentId" :options="MinorIntents" dataKey="id" optionLabel="name" optionValue="id" placeholder="Select Category" />
                      <div v-for="error in v$.NewQuestions.$each.$response.$errors[index].MinorIntentId"
                           :key="error">
                        <span class="p-error">
                          {{ error.$message }}
                        </span>
                      </div>
                    </div>
                    <div class="col-4 ml-3 flex md:justify-content-end">
                      <Button icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-outlined ml-2" @click="RemoveNewQuestion(index)" v-tooltip.top="'Remove Question'" />
                    </div>
                  </div>
                </template>
                <template #content>
                  <div class="col-11">
                    <Textarea v-model="item.QuestionStatement" :autoResize="true" rows="5" cols="30" />
                  </div>
                  <div v-for="error in v$.NewQuestions.$each.$response.$errors[index].QuestionStatement" :key="error">
                    <span class="p-error">
                      {{ error.$message }}
                    </span>
                  </div>
                </template>
              </Card>
            </div>
          </div>
    </Dialog>
  </div>
</template>

<style>
  .ag-theme-material {
    --ag-material-primary-color: #3f51b5 !important;
    --ag-material-accent-color: #ff5722 !important;
  }
  html, body, #app {
    height: 100%;
    width: 100%;
    margin: 0;
    box-sizing: border-box;
    -webkit-overflow-scrolling: touch;
  }


  .p-button.p-button-info.p-button-outlined, .p-buttonset.p-button-info > .p-button.p-button-outlined, .p-splitbutton.p-button-info > .p-button.p-button-outlined {
    background-color: transparent;
    color: #ff5722 !important;
    border: 0 none;
  }

  textarea {
    margin: 0;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
    width: 100%;
  }
</style>

<script>
  /* eslint-disable vue/no-unused-components */
  /* eslint-disable no-debugger, no-unused-vars*/
  import MultiSelect from 'primevue/multiselect';
  import InputText from 'primevue/inputtext';
  import Textarea from 'primevue/textarea';
  import Divider from 'primevue/divider';
  import Card from 'primevue/card';

  import "ag-grid-community/styles/ag-grid.css"; // Core grid CSS, always needed
  import "ag-grid-community/styles/ag-theme-material.css"; // Optional theme CSS
  import "ag-grid-enterprise";
  import { AgGridVue } from "ag-grid-vue3"

  import { LicenseManager } from "ag-grid-enterprise";
  LicenseManager.setLicenseKey("CompanyName=Inclusology,LicensedApplication=Inclusology Customer Portal,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=1,AssetReference=AG-018980,ExpiryDate=14_September_2022_[v2]_MTY2MzExMDAwMDAwMA==4484da43336c68d17edceac6ab69dc43");
  
  
  import RenderBoolValue from "../components/RenderBoolValue";
  import Toast from 'primevue/toast';
  import { useToast } from "primevue/usetoast";
  import QuestionDetail from "../components/QuestionDetail";
  import Dialog from 'primevue/dialog';
  import Button from 'primevue/button';
  import Tooltip from 'primevue/tooltip';
  import Dropdown from 'primevue/dropdown';
  import useVuelidate from '@vuelidate/core'
  import { required, helpers } from '@vuelidate/validators'
  import { reactive, ref } from 'vue'

  const state = {
    MajorIntents: [],
    MinorIntents: [],
  };

const BoolEditValues = ['Yes', 'No'];

export default {
    name: 'ManageQuestions',
    components: {
      MultiSelect,
      InputText,
      Dialog,
      Textarea,
      Divider,
      Button,
      Dropdown,
      Tooltip,
      Card,
      AgGridVue,
      RenderBoolValue,
      Toast,
      myDetailCellRenderer: QuestionDetail
    },
    props: {
    msg: String
    },
    data: () => ({
      columnDefs: [{}],
      DefaultColumnDefs: [{
        flex: 1,
        resizable: true,
        cellStyle: { "font-size": '11px', "padding-top": "1px", "padding-bottom": "1px" },
      }],
      ShowAddNewQuestionsMenu: false,
      rowSelection:'multiple',
      rowData: null,
      gridApi: null,
      CurrentUser: '',
      gridOptions: {},
      IsCreatingNewQuestions: false,
      DisableBulkOptions: true,
      BulkEditMenu: false,
      CreateOrgsOverLay: false,
      AddQuestionDialog: false,
      IsBulkEditing: false,
      BulkEdit: {
        StatusId: null,
        OrganizationId: null,
        MinorIntentId: null,
        IsCore: null,
        IsPreAssessment: null,
        IsPostAssessment: null,
        IsApproved: null,
        HasComment: null,
        Reference: null,
        Intermidiate: true
      },
      detailCellRenderer: null,
      detailRowHeight: null,
      detailCellRendererParams: {},
      groupDefaultExpanded: null,
      getRowHeight: null,
      columnApi: null,
      ConfirmDelete: false,
      sortingOrder: null,
      MajorIntents: [],
      MinorIntents: [],
      QuestionSpecs: [],
      Sections: [],
      FlagItems: [{ value: true, text: 'Yes' }, { value: false, text: 'No' }],
      OptionDefaults: [],
      QuestionTypes: [],
      ActiveStatuses: [],
      statusBar: {
        statusPanels: [
          { statusPanel: 'agTotalRowCountComponent', align: 'center' }
        ]
      },
      DynamicFilters: [1000],
      Organizations: [],
      SearchFilter: {
        OrganizationIds: [],
        MajorIntents: [],
        MinorIntents: [],
        QuestionTypes: [],
        Dates: [],
        Search: '',
        DynamicFilters: []
      },
      ShowBulkEditMenu: false,
      DateMenu: false,
      showPass: false,
      IsLoading: true,
      DeleteMenu: false,
      IsFiltering: true,
      valid: true,
      IsDeleting: false,
      EditMode: false,
      SuccessSnack: false,
      ErrorSnack: false,
      ErrorMessage: 'Error Updating User',
      SuccessMessage: 'Successfuly Updated User',
    }),
    setup() {
      const rules = {
        NewQuestions: {
          $each: helpers.forEach({
            QuestionStatement: {
              required: helpers.withMessage("A question must be added", required)
            },
            MinorIntentId: {
              required: helpers.withMessage("A category nust be assigned for this question", required)
            }
          })
        }
      }

      const state = ref({
        NewQuestions: [
          ]
      })

      const v$ = useVuelidate(rules, state)
      return { v$, state }
    },
    beforeMount() {
      this.rowSelection = 'multiple';
    },
    async created() {
      this.$emit("set-nav", this.$route)

      var self = this;
      this.detailCellRendererParams = {};
      this.detailCellRenderer = 'myDetailCellRenderer';
      this.groupDefaultExpanded = 1


      await self.$http.post('/Questions/ManagementData', {}).then(function (response) {
        if (response.data.success) {
          self.Organizations = response.data.organizations;
          self.MajorIntents = response.data.majorIntents;
          self.MinorIntents = response.data.minorIntents;
          self.Sections = response.data.sections;
          self.QuestionTypes = response.data.questionTypes;
          self.DynamicFilters = response.data.dynamicFilters;
          self.Organizations = response.data.organizations;
          self.ActiveStatuses = response.data.activeStatuses;
          self.OptionDefaults = response.data.optionDefaults;
          state.MajorIntents = response.data.majorIntents;
          state.MinorIntents = response.data.minorIntents;
          self.State = state;
        }
      })

        self.IsLoading = false;

        this.detailCellRendererParams.OptionDefaults = this.OptionDefaults;
        this.detailCellRendererParams.QuestionTypes = this.QuestionTypes;
        this.columnDefs = [
          { field: "id", hide: true },
          {
            field: "", headerName: '', maxWidth: 50, sortable: false,
            headerCheckboxSelection: true,
            checkboxSelection: true
         },
          {
            field: "intentName", headerName: 'Major Intent', sortable: true, minWidth: 200
          },
          {
            field: "orgName", headerName: "Organization",
            sortable: true,
            editable: true,
            cellEditor: 'agRichSelectCellEditor',
            cellEditorParams: { values: this.Organizations.map(x => x.orgName) },
          },
          {
            field: "minorIntentName", headerName: "Minor Intent", sortable: true, editable: true, minWidth: 200,

            cellEditor: 'agRichSelectCellEditor',
            cellEditorParams: {
              values: this.MinorIntents.map(x => x.name),
              minWidth: 200
            }
          },
          {
            field: "typeName", headerName: "Type",
            sortable: true,
            minWidth: 200,
            editable: false,
            cellRenderer: 'agGroupCellRenderer'

          },
          {
            field: "questionStatement",
            headerName: "Question",
            /* wrapText: true, resizable: true, flex: 1,*/
            autoHeight: true,
            sortable: true,
            maxWidth: 800,
            minWidth: 500,
            editable: true,
            cellEditor: 'agLargeTextCellEditor',
            cellEditorPopup: true,
            cellEditorParams: {
              maxLength: 250,
              rows: 10,
              cols: 50
            }

          },
       
         
          {
            field: "hasComment", headerName: "Comments ?", sortable: true, cellRendererFramework: "RenderBoolValue", cellStyle: { "text-align": 'center' }, maxWidth: 150,
            editable: true,
            cellEditor: 'agRichSelectCellEditor',
            cellEditorParams: { values: BoolEditValues }
          },
          {
            field: "isApproved",
            headerName: "Approved ?",
            sortable: true,
            cellRendererFramework: "RenderBoolValue",
            cellStyle: { "text-align": 'center' },
         
            editable: true,
            cellEditor: 'agRichSelectCellEditor',
            cellEditorParams: {
              values: BoolEditValues
            },
          },
          {
            field: "activeStatusName",
            headerName: "Status",
            sortable: true,
            editable: true,
            cellEditor: 'agRichSelectCellEditor',
            cellEditorParams: { values: self.ActiveStatuses.map(x => x.statusDescription) }
          }
        
        ];
        this.sortingOrder = ['asc', 'desc', null];
        this.statusBar = {
          statusPanels: [
            {
              statusPanel: 'agTotalRowCountComponent',
              align: 'right',
            },
          ],
        };

        self.FilterQuestions(undefined);
    },
    methods: {
      onFirstDataRendered(params) {
        params.api.sizeColumnsToFit();
      },
      onSelectionChanged() {
        var selectedRows = this.gridApi.getSelectedRows();
        this.DisableBulkOptions = selectedRows.length == 0;
      },
      onGridReady(params) {
        this.gridApi = params.api;
        this.gridOptions.getRowNodeId = (data) => data.id;

        this.columnApi = params.columnApi;
      },
      FilterExistingItems: function () {
        this.gridApi.setQuickFilter(this.SearchFilter.Search);
      },
      ShowBulkMenu() {
        this.ShowBulkEditMenu = true
      },
      async ShowAddNewQuestions() {
        this.state.NewQuestions = [{
          QuestionType: 1, IsApproved: true, QuestionStatement: null, QuestionKey: 1, MinorIntentId: null, IsRecommended: false, IsRanked: true, OrganizationId: 2, ActiveStatusId: 1000,
          QuestionOptions: [{
            QuestionTypeId: 1,
            QuestionKey: 1,
            QuestionOptionId: null,
            OptionValue: null,
            OptionDescription: null,
            OptionOrder: null,
            UsesDefaultOptions: true,
            DefaultOptionId: 1,
            IsCommentTriggering: false
          },
            {
              QuestionKey: 1,
              QuestionTypeId: 1,
              QuestionOptionId: null,
              OptionValue: null,
              OptionDescription: null,
              OptionOrder: null,
              UsesDefaultOptions: true,
              DefaultOptionId: 2,
              IsCommentTriggering: false
            },
            {
              QuestionKey: 1,
              QuestionTypeId: 1,
              QuestionOptionId: null,
              OptionValue: null,
              OptionDescription: null,
              OptionOrder: null,
              UsesDefaultOptions: true,
              DefaultOptionId: 3,
              IsCommentTriggering: false
            },
            {
              QuestionKey: 1,
              QuestionTypeId: 1,
              QuestionOptionId: null,
              OptionValue: null,
              OptionDescription: null,
              OptionOrder: null,
              UsesDefaultOptions: true,
              DefaultOptionId: 4,
              IsCommentTriggering: false
            },
            {
              QuestionKey: 1,
              QuestionTypeId: 1,
              QuestionOptionId: null,
              OptionValue: null,
              OptionDescription: null,
              OptionOrder: null,
              UsesDefaultOptions: true,
              DefaultOptionId: 5,
              IsCommentTriggering: false
            }
          ]
        }]
        await this.v$.NewQuestions.$reset() 
        this.ShowAddNewQuestionsMenu = true;
      },
      async AddNewCreateQuestion() {
        var questionNumber = this.state.NewQuestions.length + 1;
        this.state.NewQuestions.push({
          QuestionType: 1, IsApproved: true, ActiveStatusId:1000, QuestionStatement: null, QuestionKey: questionNumber, MinorIntentId: null, IsRecommended: false, IsRanked: true, OrganizationId: 2,
          QuestionOptions: [{
            QuestionTypeId: 1,
            QuestionKey: questionNumber,
            QuestionOptionId: null,
            OptionValue: null,
            OptionDescription: null,
            OptionOrder: null,
            UsesDefaultOptions: true,
            DefaultOptionId: 1,
            IsCommentTriggering: false
          },
          {
            QuestionKey: questionNumber,
            QuestionTypeId: 1,
            QuestionOptionId: null,
            OptionValue: null,
            OptionDescription: null,
            OptionOrder: null,
            UsesDefaultOptions: true,
            DefaultOptionId: 2,
            IsCommentTriggering: false
          },
          {
            QuestionKey: questionNumber,
            QuestionTypeId: 1,
            QuestionOptionId: null,
            OptionValue: null,
            OptionDescription: null,
            OptionOrder: null,
            UsesDefaultOptions: true,
            DefaultOptionId: 3,
            IsCommentTriggering: false
          },
          {
            QuestionKey: questionNumber,
            QuestionTypeId: 1,
            QuestionOptionId: null,
            OptionValue: null,
            OptionDescription: null,
            OptionOrder: null,
            UsesDefaultOptions: true,
            DefaultOptionId: 4,
            IsCommentTriggering: false
          },
          {
            QuestionKey: questionNumber,
            QuestionTypeId: 1,
            QuestionOptionId: null,
            OptionValue: null,
            OptionDescription: null,
            OptionOrder: null,
            UsesDefaultOptions: true,
            DefaultOptionId: 5,
            IsCommentTriggering: false
          }
          ]
        })
        await this.v$.NewQuestions.$reset() 
      },
      CreateNewQuestions() {
        var self = this;
        self.IsCreatingNewQuestions = true;

        this.$http.post('/Questions/AddNewQuestionAndOptions', {Questions: this.state.NewQuestions}).then(function (response) {
          if (response.data.success) {
            self.$toast.add({ severity: 'success', summary: 'Successfully Created Questions', life: 3000 })
            self.ShowAddNewQuestionsMenu = false;
            self.IsCreatingNewQuestions = false;
            self.ClearBulkEditMenu();
            self.gridApi.applyTransaction({ add: response.data.questions })
          }
          else {
            self.$toast.add({ severity: 'error', summary: 'Error Adding Questions', life: 3000 })
            self.ShowAddNewQuestionsMenu = false;
            self.IsCreatingNewQuestions = false;
          }
        })
      },
      RemoveNewQuestion(index) {
        this.state.NewQuestions.splice(index, 1);

        var itemNumber = 1;
        for (var i = 0; i < this.state.NewQuestions.length; i++) {
          this.state.NewQuestions[i].ItemNumber = itemNumber;
          itemNumber++;
        }
      },
      BulkEditItems: function () {

        var self = this;
        self.IsBulkEditing = true;

        var selectedRows = this.gridApi.getSelectedRows();
        var updateIds = selectedRows.map(c => c.id);
        this.BulkEdit.QuestionIds = updateIds;

        this.$http.put('/Questions/BulkUpdate', this.BulkEdit).then(function (response) {
          if (response.data.success) {
            self.$toast.add({ severity: 'success', summary: 'Update Successful', life: 3000 })
            self.ShowBulkEditMenu = false;
            self.IsBulkEditing = false;
            self.ClearBulkEditMenu();
            self.gridApi.applyTransaction({ update: response.data.questions })
          }
          else {
            self.$toast.add({ severity: 'error', summary: 'Error Updating Questions', life: 3000 })
            self.BulkEditMenu = false;
            self.IsBulkEditing = false;
          }
        })
      },
      ClearBulkEditMenu() {
        this.BulkEdit = {
          IsApproved: null,
        };
      },
      async handleCellEditing(params) {
        if (params.newValue == params.oldValue) {
          return false;
        }

        var self = this;
        var colName = null;
        var columnvalue = null;
        var updateType = null;
        var minorIntentUpdate = params.colDef.field == "minorIntentName";
        var organizationUpdate = params.colDef.field == "orgName";
        var statusUpdate = params.colDef.field == "activeStatusName";

        if (minorIntentUpdate) {
          colName = "MinorIntentId";
          columnvalue = state.MinorIntents.filter(x => x.name == params.newValue)[0].id.toString()
          updateType = 1000;
        }
        else if (organizationUpdate) {
          colName = "OrganizationId";
          columnvalue = this.Organizations.filter(x => x.orgName == params.newValue)[0].orgId.toString()
          updateType = 1000;
        }
        else if (statusUpdate) {
          colName = "ActiveStatusId"
          columnvalue = this.ActiveStatuses.filter(x => x.statusDescription == params.newValue)[0].statusId.toString()
          updateType = 1000
        }
        else {
          columnvalue = params.newValue,
            colName = params.colDef.field;
          updateType = 2000
        }

        await this.$http.post('/Questions/Update/', {
          NewValue: columnvalue,
          Id: params.node.data.id.toString(),
          ColumnName: colName,
          EditType: updateType,
          IdentityColumnName: 'id'
        }).then(function (response) {
          if (response.data.success) {

            if (statusUpdate) {
              params.node.data.activeStatusId = parseInt(columnvalue)

              params.api.refreshCells({
                force: true
              });
            }
            self.$toast.add({ severity: 'success', summary: 'Update Successful', life: 3000 })
          }
          else {
            self.$toast.add({ severity: 'error', summary: 'Error Updating Question', life: 3000 })
          }
        })
      },

      async FilterQuestions(QuestionIds) {
        var self = this;


        await this.$http.post('/Questions/FilterQuestions', self.SearchFilter).then(function (response) {
          if (response.data.success) {
              self.rowData = response.data.questions;
          }
        })
      }
    }
}</script>